import React from "react";
import PropTypes from "prop-types";
import {
  impactLabels,
  impactLookup,
  impactColorIndex,
} from "../../constants/pathogenicity";

function ImpactLabel({ impactIndex, colors }) {
  const impact = impactLookup[impactIndex];
  const backgroundColor = colors[impactColorIndex[impact]];
  const label = impactLabels[impactIndex];
  return (
    <div className="tw-flex tw-items-center">
      <div
        className="tw-w-2 tw-h-2 tw-rounded-full tw-border tw-border-gray-300"
        style={{ backgroundColor }}
      />
      <div className="tw-w-2" />
      <div className="tw-font-bold tw-capitalize">{label}</div>
    </div>
  );
}

ImpactLabel.propTypes = {
  impactIndex: PropTypes.number.isRequired,
  colors: PropTypes.arrayOf(PropTypes.string),
};

ImpactLabel.defaultProps = {
  colors: null,
};

export default React.memo(ImpactLabel);
